import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from '@mui/icons-material/Close';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';

import { makeStyles } from '@mui/styles';
import { HSATimeAgo } from '../../utility/common/GlobalHSA';

export default function NotificationItem(props) {

  const useStyles = makeStyles( theme => ({
    notificationTitle: {
      fontWeight: 'bold',
      margin: '0px',
      padding: '0px'
    },
    notificationBody: {
      margin: '0px',
      padding: '0px'
    },
    notificationNoteEllip: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },
    notificationIcon: {
      color: theme.palette.grey.main,
      fontSize: '25px',
      marginTop: '5px',
      marginLeft: '5px'
    },
    paperContent: {
      userSelect: 'none',
      padding: '10px'
    },
    paperContentClick: {
      padding: '10px',
      userSelect: 'none',
      cursor: 'pointer',
      '&:hover':{
        backgroundColor: theme.palette.tablerow.main
      }
    },
    clockIcon: {
      color: theme.palette.ltgrey.dark,
      fontSize: '20px',
      marginTop: '5px',
      marginLeft: '10px'
    },
    clockText: {
      color: theme.palette.ltgrey.dark,
    }
  }));
  const buttonclasses = useStyles();
  
  return (
    <Grid key={props.key} item xs={12} >
      <Paper className={(props.onClick)? buttonclasses.paperContentClick: buttonclasses.paperContent}>
        <Grid container justifyContent="space-between" spacing={1} alignItems="stretch" >
          <Grid item xs onClick={(props.onClick)? props.onClick: ()=>{}}>
            <Grid container justifyContent="center" spacing={1}>
              <Grid item>
                <NotificationsIcon className={buttonclasses.notificationIcon}/>
              </Grid>
              <Grid item xs zeroMinWidth>
                <p align='left' className={buttonclasses.notificationTitle} noWrap>{props.data?.title}</p>
                <p align='left' className={buttonclasses.notificationBody} noWrap>{props.data?.body}</p>
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-start" spacing={1} alignItems='center' >
              <Grid item>
                <AccessAlarmIcon className={buttonclasses.clockIcon}/>
              </Grid>
              <Grid item>
                <Typography className={buttonclasses.clockText} align='left' variant="subtitle2">
                  {(props.data?.data?.dated)? HSATimeAgo(props.data?.data?.dated) : ''}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <IconButton 
              size="small"
              onClick={(props.onDismiss)? props.onDismiss : ()=>{}}>
                <CloseIcon fontSize="small" color="grey" />
            </IconButton>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}